import { CheckCircleIcon } from '@chakra-ui/icons';
import { Button, Icon, Stack, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import { routes } from '@blockpulse3/data/shared';

import { useUser } from '../../providers';

type Props = unknown;

export function VerifyEmailSuccess(): JSX.Element {
  const i18nVerifyEmailForm = useTranslations('VerifyEmailForm');

  const navigate = useNavigate();
  const { loadUser } = useUser();

  const onClick = (): void => {
    loadUser();
    navigate(routes.me.href);
  };

  return (
    <Stack align="center" direction="column" spacing="8">
      <Stack direction="row" gap="4">
        <Icon as={CheckCircleIcon} boxSize="8" color="green.500" />
        <Text fontSize="xl" fontWeight="bold">
          {i18nVerifyEmailForm('EmailVerificationSuccess')}
        </Text>
      </Stack>
      <Button width="full" onClick={onClick}>
        {i18nVerifyEmailForm('LogIn')}
      </Button>
    </Stack>
  );
}

export type VerifyEmailSuccessProps = Props;
